export const APPLIED_JOBS_STATUS = {
    applied: "Applied",
    interviewScheduled: "interview scheduled",
    interviewDone: "Interview Done",
    interviewLinkExpired: "Link Expired",
    notSelected: "not selected",
    inReview: 'eligible',
    hired: 'Hired',
}

// JOB APPLIED STATUS

// 1. Applied ( applied for the job)
// 2.a Eligible // After Cv ranking
// 2.b Not Selected ( ) // 
// 2.a.1 Interview Scheduled ( ) // after intreview email is send
// 2.a.2 Interview Done // 
// 2.a.2 Process completed // after sumarry is created
//


